import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCirclePause } from '@fortawesome/pro-light-svg-icons';

export type ProLightCirclePauseProps = IconComponentProps;

export const ProLightCirclePause = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCirclePauseProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCirclePause}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCirclePause}
    />
  );
};

ProLightCirclePause.displayName = 'ProLightCirclePause';
